import * as React from 'react';
import * as styles from './Advantages.css';

export const Advantages = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles['advantages']}>{children}</div>;
};
